"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withEvents = exports.EventsProvider = exports.useEvents = void 0;
var create_event_tooling_1 = require("./create-event-tooling");
var _a = (0, create_event_tooling_1.createEventTooling)(), useEvents = _a.useEvents, EventsProvider = _a.EventsProvider, withEvents = _a.withEvents;
exports.useEvents = useEvents;
exports.EventsProvider = EventsProvider;
exports.withEvents = withEvents;
